module.exports = __webpack_public_path__ + "assets/img/step8-2-sz.47ac9d80.png";